class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    // An add already rendered the drawer from its own response; fetching the
    // section again would only repeat that work.
    if (this.rendered) {
      document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      return;
    }

    this.loadSection();
  }

  loadSection() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        // An add on its way or already rendered brings newer contents; this
        // response may predate it.
        if (this.rendered || this.classList.contains('is-updating')) return;
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  // From the tap until the add returns: drawer open, a placeholder row on top,
  // the empty-cart panel out of the way.
  showAdding() {
    const form = this.querySelector('.mini-cart');
    const main = this.querySelector('#main-cart-items');
    const skel = document.createElement('div');
    skel.className = 'cart-skel';
    skel.setAttribute('aria-hidden', 'true');
    skel.innerHTML = '<span></span><span></span><span></span>';
    this.classList.add('is-updating');
    if (form && main) {
      this.wasEmpty = form.classList.contains('is-empty');
      form.classList.remove('is-empty');
      if (!main.querySelector('.cart-skel')) main.prepend(skel);
    } else if (!this.querySelector('.cart-skel')) {
      // The drawer section loads on first open, so on a fresh page there is
      // nothing yet; show the placeholder on its own.
      skel.classList.add('cart-skel--bare');
      this.innerHTML = '';
      this.append(skel);
    }
    this.open();
  }

  cancelAdding() {
    if (!this.classList.contains('is-updating')) return;
    this.classList.remove('is-updating');
    const skel = this.querySelector('.cart-skel');
    if (skel) skel.remove();
    const form = this.querySelector('.mini-cart');
    if (form && this.wasEmpty) form.classList.add('is-empty');
    // Nothing was ever loaded into the drawer: fetch it now.
    if (!form && !this.rendered) this.loadSection();
    if (this.drawer) this.drawer.closeMenuDrawer(new Event('cart:error'));
  }

  renderContents(parsedState) {
    this.rendered = true;
    this.classList.remove('is-updating');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
